<template>
  <div>
    <Header />
    <Details />
    <Footer />
    <SocialLinks right="10" />
  </div>
</template>

<script>
  import Header from '../components/common/Header'
  import Details from '../components/OurHousesDetails/Details'
  import Footer from '../components/common/Footer'
  import SocialLinks from '../components/common/SocialLinks'

  export default {
    name: 'OurHousesDetails',
    metaInfo: {
      title: 'Our Houses',
    },
    components: {
      Header,
      Details,
      Footer,
      SocialLinks
    },
    watch: {
        $route(to) {
            console.log(to)
            this.currentUser = to
        }
    }
  }
</script>

<style scoped>
</style>